// extracted by mini-css-extract-plugin
export default {"Switch":"ToggleSwitch_Switch__iDMgY","CheckInput":"ToggleSwitch_CheckInput__VHrWj","Slider":"ToggleSwitch_Slider__fJhec","Round":"ToggleSwitch_Round__-GSka"};